import React from 'react';
import { toast } from 'sonner';
import { CellParams } from './useColumns';
import UIStrings from '@/Utils/UIStrings';
import { useUpdateShortlistedProfilesStatus } from '../../../../api/useShortlistedProfiles';
import { useShortlistedListContext } from '../ShortlistedListContext';
import ShortlistedStatusAction from '../../components/ShortlistedStatusAction';
import { useOutreachCandidatePopoutContext } from '../../Outreach/OutreachContext';
import { useLinkedInMessageOutreach } from '@/Pages/Candidates/AiSearch/api/useOutreachCandidate';
import { ShortlistedStatus } from '@/Pages/Candidates/AiSearch/api/DTO/ShortlistedProfile';
import htmlToPlainText from '@/Pages/Candidates/AiSearch/utils/htmlToPlainText';

const StatusCell = ({ row }: CellParams) => {
    const { status: profileStatus, id } = row.original;
    const { mutate: mutateShortlistedProfiles } = useShortlistedListContext();
    const { trigger: triggerStatusChange } = useUpdateShortlistedProfilesStatus();
    const { openLinkedInMessagePopout } = useOutreachCandidatePopoutContext();
    const { data: linkedInMessage } = useLinkedInMessageOutreach();

    const handleOnClickMenuItem = async (newStatus: ShortlistedStatus) => {
        if (newStatus === 'ContactTaskInMail') {
            if (!linkedInMessage) {
                openLinkedInMessagePopout([{ ...row.original.profile, id }]);
                return;
            }

            const plainText = htmlToPlainText(linkedInMessage.message || '');

            const clipboardItem = new ClipboardItem({
                'text/html': new Blob([linkedInMessage.message], { type: 'text/html' }),
                'text/plain': new Blob([plainText], { type: 'text/plain' }),
            });

            navigator.clipboard.write([clipboardItem]);
        }

        await triggerStatusChange({ shortlistedProfilesIds: [id], shortlistedStatus: newStatus });

        toast.success(UIStrings.NumberOfCandidateStatus(1, UIStrings[newStatus]));
        mutateShortlistedProfiles();
    };

    return <ShortlistedStatusAction onChangeCallback={handleOnClickMenuItem} profileStatus={profileStatus} />;
};

export default StatusCell;
